import React from 'react';

import Spinner from '@core/components/spinner/Spinner';
import { useQuery } from 'react-query';
import { GetUserDashboard } from 'services/core';
import { consultations } from 'services/consultation';
import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import DashboardMenuDesktop from '@core/components/dashboardMenuDesktop/DashboardMenuDesktop';
import VipConsultationWrapper from 'components/pages/vip-consultation/VipConsultationWrapper';

import classes from './VipConsultation.module.scss';

const index = () => {
    const { data, isLoading } = useQuery('consultation-status', () => consultations.GET());

    const seoProps = generateSeoProps({
        title: 'Career Coaching: Resume, Interview & Visa Tips - Pharmuni',
        description: 'Book free 30-min sessions with a pharma expert. Get resume feedback, mock interviews and career path guidance—accelerate your industry growth.',
        canonical: 'vip-consultation'
    });
    return (
        <>
            <NextSeo {...seoProps} />
            {isLoading ? (
                <div className={classes['loading']}>
                    <Spinner />
                </div>
            ) : (
                <>
                    {data && (
                        <VipConsultationWrapper data={data.data} />
                    )}
                </>
            )}
        </>
    );
};

export default index;